import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { BusinessDtoModel } from 'models/generated/Models.LeadsApi.BusinessDto';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class LeadsService {
	private baseUrl = `${environment.gatewayUrl}/api/leads`;

	constructor(private readonly http: HttpClient) {
		
	}

	getLeads(zip: string, limit: number, list?: string): Promise<BusinessDtoModel[]> {
		return firstValueFrom(this.http.get<BusinessDtoModel[]>(`${this.baseUrl}?zip=${zip}&limit=${limit}&list=${list ? list : ''}`));
	}

	getVatNumber(company: BusinessDtoModel): string {
		if (company.businessId.length === 10) {
			return company.businessId.substring(2, 10);
		}
		return company.businessId;
	}

	getCountryCode(company: BusinessDtoModel): string {
		if (company.businessId.length >= 2) {
			return company.businessId.substring(0, 2);
		}
		return '';
	}
}
